import React from "react";
import "../DevelopmentProcess.css";

import {
  FaComments,
  FaClipboardList,
  FaPencilRuler,
  FaCode,
  FaVial,
  FaRocket,
} from "react-icons/fa";

const process = [
  {
    number: "01",
    icon: <FaComments />,
    title: "Discovery & Consultation",
    description:
      "We understand your business objectives, challenges, and project requirements to define the right technology strategy.",
  },
  {
    number: "02",
    icon: <FaClipboardList />,
    title: "Planning & Strategy",
    description:
      "Our experts prepare a detailed roadmap, architecture, timelines, and development plan to ensure project success.",
  },
  {
    number: "03",
    icon: <FaPencilRuler />,
    title: "UI/UX Design",
    description:
      "We design intuitive, engaging, and user-friendly interfaces that provide exceptional digital experiences.",
  },
  {
    number: "04",
    icon: <FaCode />,
    title: "Development",
    description:
      "Using modern technologies and agile methodologies, we build secure, scalable, and high-performance applications.",
  },
  {
    number: "05",
    icon: <FaVial />,
    title: "Testing & Quality Assurance",
    description:
      "Every solution undergoes rigorous testing to ensure reliability, security, performance, and a seamless user experience.",
  },
  {
    number: "06",
    icon: <FaRocket />,
    title: "Deployment & Support",
    description:
      "After successful deployment, we provide continuous monitoring, maintenance, updates, and long-term technical support.",
  },
];

const DevelopmentProcess = () => {
  return (
    <section className="process">

      <div className="process-container">

        <span className="section-tag">
          OUR DEVELOPMENT PROCESS
        </span>

        <h2>
          From <span>Vision</span> to <span>Reality</span>
        </h2>

        <p className="process-intro">
          Every successful digital product starts with a well-defined process.
          At VisionVote Technologies, we follow an agile, transparent, and
          collaborative approach that ensures quality, innovation, and timely
          delivery from concept to deployment.
        </p>

        <div className="process-grid">

          {process.map((step, index) => (
            <div className="process-card" key={index}>

              <div className="process-number">
                {step.number}
              </div>

              <div className="process-icon">
                {step.icon}
              </div>

              <h3>{step.title}</h3>

              <p>{step.description}</p>

            </div>
          ))}

        </div>

      </div>

    </section>
  );
};

export default DevelopmentProcess;